const navBtn = document.querySelector('#navBtn');
const nav = document.querySelector('#nav');
const header = document.querySelector('#headerWrapper');

if (navBtn) {

    navBtn.addEventListener('click', () => {
        navBtn.classList.toggle('is-active');
        nav.classList.toggle('is-active');
		header.classList.toggle('is-active');

		// change aria-expanded on click
		let ariaExpanded = navBtn.getAttribute('aria-expanded');

		if (ariaExpanded === "true") {
			ariaExpanded = "false"
		} else {
			ariaExpanded = "true"
		}

		navBtn.setAttribute('aria-expanded', ariaExpanded);
    })
}
